import React from 'react';
import { Stack } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { formatStringToNumber } from 'utils/formatters';
import { InputField, SelectField } from 'components/form';
import { EquipmentFormValue } from '../../../../types';
import { FieldsContainer } from '../../../components/FieldsContainer';
import { equipmentConditions, inventoryItemStatuses } from '../../../../constants';
import { EQUIPMENT_CLASS } from '@trnsact/business-criteria';
import { StandardInfoSingle } from '../../../standartInfo';

const equipmentClassOptions = Object.values(EQUIPMENT_CLASS).map(option => ({
  label: option,
  value: option,
}));

export const CommonInfo = () => {
  const { control } = useFormContext<EquipmentFormValue>();

  return (
    <FieldsContainer columns={5}>
      <Stack direction="row" gap="0.5rem">
        <InputField
          label="Quantity"
          control={control}
          name="commonInfo.quantity"
          formatter={formatStringToNumber}
          inputProps={{
            type: 'number',
            required: true,
            variant: 'outlined',
          }}
        />
      </Stack>

      <StandardInfoSingle />

      <SelectField
        label="Condition"
        control={control}
        variant="outlined"
        name="commonInfo.condition"
        options={equipmentConditions}
      />

      <InputField label="Serial/VIN#" name="commonInfo.vin" control={control} inputProps={{ variant: 'outlined' }} />

      <InputField label="Stock ID" name="commonInfo.stockId" control={control} inputProps={{ variant: 'outlined' }} />

      <InputField
        label="Mileage"
        control={control}
        name="commonInfo.mileage"
        formatter={formatStringToNumber}
        inputProps={{ type: 'number', variant: 'outlined' }}
      />

      <SelectField
        label="Class"
        control={control}
        variant="outlined"
        name="commonInfo.class"
        options={equipmentClassOptions}
      />

      <SelectField
        label="Status"
        control={control}
        variant="outlined"
        name="commonInfo.inventoryItem.status"
        options={inventoryItemStatuses}
      />

      <InputField
        control={control}
        label="Description"
        name="commonInfo.description"
        inputProps={{
          minRows: 3,
          multiline: true,
          variant: 'outlined',
          sx: { gridColumn: '1 / 6' },
        }}
      />
    </FieldsContainer>
  );
};
